import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

// -- actions
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- constants
import Events from 'constants/Events';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- utils
import { StringUtils } from 'PMT/utils';

// -- entities
import MenuPartCategory from 'PMT/entities/menu/MenuPartCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import Product from 'PMT/entities/menu/Product';
import Menu from 'PMT/entities/menu/Menu';
import MenuPartItem from 'PMT/entities/menu/MenuPartItem';

// -- views
import AbstractComponent from 'components/AbstractComponent';
import SearchBox from 'PMT/components/SearchBox';
import SubmitArea from 'PMT/components/form/SubmitArea';
import { Tabs, Tab } from 'react-bootstrap';
import ProductItem from './components/ProductItem';
import CategoryItem from './components/CategoryItem';

class View extends AbstractComponent {
  static propTypes = {
    category: PropTypes.instanceOf(MenuPartCategory),

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu),
  };

  state = {
    searchQuery: '',

    category: this.props.category.copy(),

    productAddSearchQuery: '',

    productRemoveSearchQuery: '',

    categoryAddSearchQuery: '',

    categoryRemoveSearchQuery: '',
  };

  componentDidMount() {
    RestaurantMenuStore.addListener(
      Events.ON_UPDATE_RESTAURANT_MENU_ERROR,
      this.onError
    );

    RestaurantMenuStore.addListener(
      Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
      this.onSuccess
    );
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(
      Events.ON_UPDATE_RESTAURANT_MENU_ERROR,
      this.onError
    );

    RestaurantMenuStore.removeListener(
      Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
      this.onSuccess
    );
  }

  get restaurantMenu(): RestaurantMenu {
    return this.props.restaurantMenu;
  }

  get category(): MenuPartCategory {
    return this.state.category;
  }

  get haveModifications(): boolean {
    return !this.state.category.equals(this.props.category);
  }

  // --
  onError = () => {
    // TODO: onError
    this.hideLoading();
    alert('an error occured');
  };

  onSuccess = () => {
    this.hideLoading();
    this.props.onHide();
  };

  // --

  onSelectAllProducts = products => {
    const category = this.category

    _.forEach(products, product => {
      const item: MenuPartItem = new MenuPartItem()
      item.type = MenuPartItem.Type.PRODUCT
      item.id = product.id

      category.items.push(item)
    })

    this.setState({
      category,
    })
  }

  onDeselectAllProducts = products => {
    const category = this.category

    _.forEach(products, product => {
      category.removeProductWithId(product.id)
    })

    this.setState({
      category,
    })
  }

  onDeselectProduct = (product: Product) => {
    const category = this.category;

    category.removeProductWithId(product.id);

    this.setState({
      category,
    });
  };

  onSelectProduct = (product: Product) => {
    const category = this.category;

    const item: MenuPartItem = new MenuPartItem();
    item.type = MenuPartItem.Type.PRODUCT;
    item.id = product.id;

    category.items.push(item);

    this.setState({
      category,
    });
  };

  onDeselectCategory = (categoryToDeselect: Category) => {
    const category = this.category;

    category.removeCategoryWithId(categoryToDeselect.id);

    this.setState({
      category,
    });
  };

  onSelectCategory = (categoryToSelect: Category) => {
    const category = this.category;
    category.addCategory(categoryToSelect);

    this.setState({
      category,
    });
  };

  // -- search
  onProductAddSearchQueryChange = productAddSearchQuery => {
    this.setState({
      productAddSearchQuery,
    });
  };

  onProductRemoveSearchQueryChange = productRemoveSearchQuery => {
    this.setState({
      productRemoveSearchQuery,
    });
  };

  onCategoryAddSearchQueryChange = categoryAddSearchQuery => {
    this.setState({
      categoryAddSearchQuery,
    });
  };

  onCategoryRemoveSearchQueryChange = categoryRemoveSearchQuery => {
    this.setState({
      categoryRemoveSearchQuery,
    });
  };

  // -- form
  onSubmit = () => {
    const menuPart = this.props.menuPart;
    const menu = this.props.menu;

    this.showLoading();
    RestaurantMenuAction.updateMenuPartCategory(
      menu,
      menuPart,
      this.state.category
    );
  };

  onReset = () => {
    this.setState({
      category: this.props.category.copy(),
    });
  };

  // -- renderers

  renderSearchNoResults() {
    return (
      <p>
        <em>{I18n.tr('menu.upselling_category.add_item.search_no_results')}</em>
      </p>
    );
  }

  renderProductsSelected(products: Array<Product>) {
    let listView = null;
    let sortedProductsList = []

    if (
      _.isEmpty(products) &&
      !_.isEmpty(this.state.productRemoveSearchQuery)
    ) {
      listView = this.renderSearchNoResults();
    } else if (
      _.isEmpty(products) &&
      _.isEmpty(this.state.productRemoveSearchQuery)
    ) {
      listView = (
        <p>
          <em>
            {I18n.tr('menu.upselling_category.add_item.no_item_selected')}
          </em>
        </p>
      );
    } else {
      sortedProductsList = _.sortBy(
        products,
        ['desc'],
        (product: Product): number => {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return StringUtils.toAlphaNum(product.name).toLowerCase();
        }
      );
      listView = sortedProductsList.map((product: Product) => {
        return (
          <ProductItem
            key={product.id}
            product={product}
            isSelected
            onDeselect={this.onDeselectProduct}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__products__selected">
        <h4>{I18n.tr('menu.upselling_category.add_item.selected')}</h4>

        <SearchBox
          search={this.state.productRemoveSearchQuery}
          onSearchInput={this.onProductRemoveSearchQueryChange}
        />

        {listView.length > 0 && (
          <div
            className="product_item pointer"
            onClick={() => this.onDeselectAllProducts(sortedProductsList)}
          >
            <i className="fa fa-check-square-o" />
            &nbsp;&nbsp;{I18n.tr('menu.menu_part_category.uncheck_all')}
          </div>
        )}

        <div className="list">{listView}</div>
      </div>
    );
  }

  renderProductsUnselected(products: Array<Product>) {
    let listView = null;
    let sortedProductsList = []

    if (_.isEmpty(products)) {
      listView = this.renderSearchNoResults();
    } else {
      sortedProductsList = _.sortBy(
        products,
        ['desc'],
        (product: Product): number => {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return StringUtils.toAlphaNum(product.name).toLowerCase();
        }
      );
      listView = sortedProductsList.map((product: Product) => {
        return (
          <ProductItem
            key={product.id}
            product={product}
            isSelected={false}
            onSelect={this.onSelectProduct}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__products__unselected">
        <h4>{I18n.tr('menu.upselling_category.add_item.products_on_menu')}</h4>

        <SearchBox
          search={this.state.productAddSearchQuery}
          onSearchInput={this.onProductAddSearchQueryChange}
        />

        {listView.length > 0 && (
          <div
            className="product_item pointer"
            onClick={() => this.onSelectAllProducts(sortedProductsList)}
          >
            <i className="fa fa-square-o" />
            &nbsp;&nbsp;{I18n.tr('menu.menu_part_category.check_all')}
          </div>
        )}

        <div className="list">{listView}</div>
      </div>
    );
  }

  renderProducts() {
    const unselected = [];
    const selected = [];

    _.each(this.props.menuPart.products, (item: MenuPartProduct) => {
      const product = this.props.restaurantMenu.getProductWithId(item.id);
      if (!_.isNil(product)) {
        const isSelected = !_.isUndefined(
          _.find(this.category.items, (item: MenuPartItem) => {
            return item.isProduct() && item.id === product.id;
          })
        );

        if (isSelected) {
          const query: string = this.state.productRemoveSearchQuery;
          if (
            _.isEmpty(query) ||
            StringUtils.searchStringOn(query, product.name)
          ) {
            selected.push(product);
          }
        } else {
          const query: string = this.state.productAddSearchQuery;
          if (
            _.isEmpty(query) ||
            StringUtils.searchStringOn(query, product.name)
          ) {
            unselected.push(product);
          }
        }
      }
    });

    return (
      <div className="row add_to_category_view__products">
        {this.renderProductsUnselected(unselected)}
        {this.renderProductsSelected(selected)}
      </div>
    );
  }

  renderCategoriesSelected(categories: Array<MenuPartCategory>) {
    let listView = null;
    if (_.isEmpty(categories) && !_.isEmpty(this.state.menuRemoveSearchQuery)) {
      listView = this.renderSearchNoResults();
    } else if (
      _.isEmpty(categories) &&
      _.isEmpty(this.state.menuRemoveSearchQuery)
    ) {
      listView = (
        <p>
          <em>
            {I18n.tr('menu.upselling_category.add_item.no_menu_selected')}
          </em>
        </p>
      );
    } else {
      listView = categories.map(category => {
        return (
          <CategoryItem
            key={category.id}
            category={category}
            isSelected
            onDeselect={this.onDeselectCategory}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__menus__selected">
        <h4>{I18n.tr('menu.upselling_category.add_item.selected')}</h4>

        <SearchBox
          search={this.state.menuRemoveSearchQuery}
          onSearchInput={this.onMenuRemoveSearchQueryChange}
        />
        <div className="list">{listView}</div>
      </div>
    );
  }

  renderCategoriesUnselected(categories: Array<MenuPartCategory>) {
    let listView = null;
    if (_.isEmpty(categories)) {
      listView = this.renderSearchNoResults();
    } else {
      listView = categories.map((category: MenuPartCategory) => {
        return (
          <CategoryItem
            key={category.id}
            category={category}
            isSelected={false}
            onSelect={this.onSelectCategory}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__categories__unselected">
        <h4>
          {I18n.tr('menu.menu_part_category.add_item.categories_on_menu')}
        </h4>

        <SearchBox
          search={this.state.categoryAddSearchQuery}
          onSearchInput={this.oncategoryAddSearchQueryChange}
        />
        <div className="list">{listView}</div>
      </div>
    );
  }

  renderCategories() {
    const unselected = [];
    const selected = [];

    _.each(this.props.menuPart.categories, (category: MenuPartCategory) => {
      if (!category.isRootCategory()) {
        const isSelected = !_.isUndefined(
          _.find(this.category.items, (item: MenuPartItem) => {
            return item.isCategory() && item.id === category.id;
          })
        );

        if (isSelected) {
          const query: string = this.state.menuRemoveSearchQuery;
          if (
            _.isEmpty(query) ||
            StringUtils.searchStringOn(query, category.name)
          ) {
            selected.push(category);
          }
        } else {
          const query: string = this.state.menuAddSearchQuery;
          if (
            _.isEmpty(query) ||
            StringUtils.searchStringOn(query, category.name)
          ) {
            unselected.push(category);
          }
        }
      }
    });

    return (
      <div className="row add_to_category_view__categories">
        {this.renderCategoriesUnselected(unselected)}
        {this.renderCategoriesSelected(selected)}
      </div>
    );
  }

  renderSubmitArea() {
    return (
      <SubmitArea
        haveModifications={this.haveModifications}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
      />
    );
  }

  render() {
    return (
      <div className="add_to_menu_part_category_view">
        <Tabs
          defaultActiveKey={1}
          id="edit_restaurant_page__tabs"
          onSelect={this.onTabChange}
        >
          <Tab eventKey={1} title={I18n.tr('menu.menu_part_category.products')}>
            <div className="top-buffer-30">{this.renderProducts()}</div>
          </Tab>

          <Tab eventKey={2} title={I18n.tr('menu.menu_part_category.categories')}>
            <div className="top-buffer-30">{this.renderCategories()}</div>
          </Tab>
        </Tabs>

        {this.renderSubmitArea()}

        {this.renderLoading()}
      </div>
    );
  }
}

export default View;
